import { isLocalSearchRuntime } from './searchSubmit';

/**
 * Whether SERP URL params scope results away from the full product catalog.
 * @param {URLSearchParams} searchParams
 */
export function isScopedSearchParams(searchParams) {
  // Local dev: empty q browse is intentional (full catalog).
  if (isLocalSearchRuntime()) {
    return true;
  }

  if ((searchParams.get('q') ?? '').trim() !== '') {
    return true;
  }
  if ((searchParams.get('shop') ?? '').trim() !== '') {
    return true;
  }
  if (searchParams.get('sale') === '1') {
    return true;
  }
  if ((searchParams.get('website') ?? '').trim() !== '') {
    return true;
  }
  const category = searchParams.get('category') ?? '';
  return /^\d+$/.test(category);
}
